import { createStore, applyMiddleware, compose } from 'redux';
import createForwardActionsMiddleware from './createForwardActionsMiddleware';
import reducer from './reducer';
import composeWithDevTools from './composeWithDevTools';

const state = initState => {
  const reduxDevToolsEnabled =
    process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test';
  const initialState = initState || {
    root: null,
    components: {},
    componentsProperties: {},
  };
  const composeWith = reduxDevToolsEnabled ? composeWithDevTools() : compose;

  return createStore(
    reducer,
    initialState,
    composeWith(
      applyMiddleware(
        createForwardActionsMiddleware({
          incomingTopic: 'wh.mtt.command.redux.dispatch',
          outgoingTopic: 'wh.mtt.command.logic.send',
          match: action => action.type.startsWith('VIEW_'),
        })
      )
    )
  );
};

export default state;
